import type { GenieKnowledgeEntry } from '../../types';

export const radiculopathy: GenieKnowledgeEntry = {
  id: 'radiculopathy',
  name: 'Radiculopatía',
  category: 'neuropatico',
  conversation: {
    headline:
      'Compromiso de raíz espinal. EMG confirma denervación en miótoma específico; NCS sensitivas suelen ser normales.',
    edxHighlights: [
      'EMG: fibrilaciones/PSW en músculos del miótoma afectado',
      'PUMs neurogénicos crónicos en músculos radiculares',
      'NCS motor/sensitivo de extremidad frecuentemente normal',
      'Paraespinales: fibrilaciones confirman lesión radicular proximal',
    ],
    pearls: [
      'NCS normal NO descarta radiculopatía — la aguja es más sensible.',
      'Radiculopatía múltiple vs polineuropatía: distribución miótomal vs simétrica distal.',
    ],
    differentials: [
      { name: 'Plexopatía', distinguishingHint: 'patrón regional asimétrico que cruza miótomas' },
      { name: 'Mononeuropatía', distinguishingHint: 'distribución del nervio periférico, no del miótoma' },
    ],
    nextSteps: [
      'Muestrear músculos proximales y paraespinales del nivel sospechoso',
      'Correlacionar con imagen (RM) si indicado',
    ],
  },
  orientationHints: {
    temporalFit: ['acute', 'subacute', 'chronic'],
    whenToSuspect: 'Dolor radicular + debilidad en distribución miótomal',
  },
};
